import React from 'react'
import {error_log_report} from "../api/api";
import {Button} from 'antd'
import {DownloadOutlined} from "@ant-design/icons"
import {DefaultProps, PaginatedLoad, Refresh, RefTable} from "./RefTable";

export const ErrorLogs = (props)=><RefTable {...props}/>;

ErrorLogs.defaultProps = {
    ...DefaultProps,
    title: "Error Logs",
    tableSchema: "error_logs",
    tableName: "error_logs",
    filterSchema:"error_log_filter",
    edit: false,
    add: false,
    theadHeight: 40,
    tfootHeight: 50,
    customActionElements:[<Refresh key={"refresh-action"}/>, <Button key={`action-download`} icon={<DownloadOutlined/>} onClick={async ()=>error_log_report()}>Download CSV</Button>],
    fetch: PaginatedLoad
}
